import { jsx as _jsx } from "react/jsx-runtime";
import './IconToken.scss';
// Category/ability colors are all 6-digit hex, so we expand them to rgba() here
// and avoid color-mix() (not used elsewhere in the project's build).
const hexToRgba = (hex, alpha) => {
    const value = hex.replace('#', '');
    const r = parseInt(value.slice(0, 2), 16);
    const g = parseInt(value.slice(2, 4), 16);
    const b = parseInt(value.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
// A rounded, tinted icon chip that carries a row's category by color + glyph.
// Replaces the old left accent bars on the node and event editor rows.
export const IconToken = ({ color, placeholder, className, title, children }) => {
    const style = {
        '--token-color': color,
        '--token-bg': hexToRgba(color, 0.14),
        '--token-border': hexToRgba(color, 0.3),
    };
    return (_jsx("span", { className: `icon-token${placeholder ? ' placeholder' : ''}${className ? ` ${className}` : ''}`, style: placeholder ? undefined : style, title: title, children: children }));
};
